/**
 * Created by tomers on 1/5/2017.
 */
define(function (require) {
    "use strict";

    var LE = require("app");
    var UsersCollection = require("collections/entities/UsersCollection");
    var DateUtility = require("utils/DateUtility");

    var DAYS_TO_FETCH_AUDIT = 31;

    var AuditTrailFilters = [];

    function moduleDefinition(LEManager, LE, Backbone, Marionette, $, _) {
        AuditTrailFilters = [
            {
                name: "componentTypes",
                type: Marionette.GraphQLGridView.FILTERS.TYPES.MULTISELECT,

                getFilterData: function () {
                    var dataManager = LEManager.getModuleDataManager();
                    var auditTrailCollection = dataManager.getData(dataManager.getEntities().AUDIT_TRAIL);

                    var valuesArr = [];
                    _.each(auditTrailCollection.OBJECT_TYPES, function(val, key) {
                        valuesArr.push({id: val, value: LE.translator.translate("LEManager.auditTrail.columns.objectType.filter.options."+val)});
                    });

                    return {
                        valuesArr: valuesArr,
                        placeholderText: LE.translator.translate("LEManager.auditTrail.columns.objectType.filter.placeholder")
                    };
                }
            },
            {
                name: "fullUsers",
                type: Marionette.GraphQLGridView.FILTERS.TYPES.MULTISELECT,

                getFilterData: function () {
                    var dataManager = LEManager.getModuleDataManager();
                    var auditTrailCollection = dataManager.getData(dataManager.getEntities().AUDIT_TRAIL);

                    var valuesArr = auditTrailCollection.getFilterValue(auditTrailCollection.FILTERS_ENUM.FULL_USERS) || [];

                    var additionalFilterGroup = LE.translator.translate("LEManager.auditTrail.columns.originator.filter.group.additional");
                    var usersFilterGroup = LE.translator.translate("LEManager.auditTrail.columns.originator.filter.group.users");

                    var filterUsers = function(componentId, eventName, options) {
                        var successCallback = options.success;
                        var startsWith = options.value;

                        var usersCollection = new UsersCollection([], {urlSelectParameter:UsersCollection.URL_SELECT_PARAMETER.PARTIAL});
                        usersCollection.fetch({
                            data: {
                                "startsWith": startsWith,
                                "offset": 0,
                                "first": 200,
                                "include_deleted": true,
                                "orderBy": "fullName",
                                "orderDirection": "asc"
                            },
                            success: function(collection, response, options) {
                                // Map usersCollection to Multiselect.Collection
                                var usersCollection = collection.map(function(item){
                                    var id = item.id.toString();
                                    var value = item.get("fullName");
                                    var subText = item.get("loginName");
                                    if (item.get("deleted")) {
                                        subText += " - " + LE.translator.translate("LEManager.auditTrail.columns.originator.filter.deletedText");
                                    }

                                    return {
                                        "id": id,
                                        "value": value,
                                        "subText": subText,
                                        "group": usersFilterGroup
                                    };
                                });

                                usersCollection.push({
                                    "id": auditTrailCollection.FILTERS_ENUM.INCLUDE_LPA,
                                    "value": LE.translator.translate("LEManager.auditTrail.columns.originator.filter.group.additional.LPA.label"),
                                    "group": additionalFilterGroup,
                                    "notAffectedByFilter": true
                                });

                                usersCollection.push({
                                    "id": auditTrailCollection.FILTERS_ENUM.INCLUDE_AUTOMATIC_UPDATES,
                                    "value": LE.translator.translate("LEManager.auditTrail.columns.originator.filter.group.additional.automatic.label"),
                                    "group": additionalFilterGroup,
                                    "notAffectedByFilter": true
                                });

                                successCallback(usersCollection);
                            }
                        });
                    };

                    return {
                        valuesArr: valuesArr,
                        placeholderText: LE.translator.translate("LEManager.auditTrail.columns.originator.filter.placeholder"),
                        saveFullData: true,
                        componentOptions: {
                            asyncFilter: true,
                            asyncFilterMinChars: 2,
                            trim: false,
                            list: {
                                groupsOrder: [additionalFilterGroup, usersFilterGroup]
                            }
                        },
                        componentEvents: {
                            "filter": filterUsers
                        }
                    };
                }
            },
            {
                name: "changeDate",
                type: Marionette.GraphQLGridView.FILTERS.TYPES.TIMEFRAME,

                getFilterData: function () {
                    var dataManager = LEManager.getModuleDataManager();
                    var auditTrailCollection = dataManager.getData(dataManager.getEntities().AUDIT_TRAIL);

                    var defaultStartDate = new Date();
                    defaultStartDate.setDate(defaultStartDate.getDate() - DAYS_TO_FETCH_AUDIT + 1); // start date is 31 days ago. this is now() - 30 days. so we take the CONSTANT and add 1.

                    var defaultExpirationDate = new Date();

                    return {
                        componentOptions: {
                            timezoneId: LE.siteSettings.timeZoneSettings.getCurrentTimeZoneTranslated(auditTrailCollection.getFilterValue(auditTrailCollection.FILTERS_ENUM.TIMEZONE))
                        },
                        selectedValues: {
                            startDate: DateUtility.date2Str(defaultStartDate, true),
                            expirationDate: DateUtility.date2Str(defaultExpirationDate, true)
                        }
                    };
                }
            }
        ];
    }

    LE.module("LEManager", moduleDefinition);

    return AuditTrailFilters;
});
